import React from 'react'
import { formatPlaceForForm } from '../../_data/formatPlaceForForm'
import { usePlace } from '../_load/PlaceLoader'

export const usePlaceFormattedFormData = () => {
  const place = usePlace()
  return React.useMemo(() => {
    return place ? formatPlaceForForm(place) : undefined
  }, [place])
}
